import { CTooltip } from "@coreui/react";
import { Card, CardBody, CardHeader, CardTitle, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function ClassSequence({
  question,
  answersStudent,
  correctAnswer,
  students,
  amountOfStudentresults,
  sliderSettings,
  questionIndex,
}) {
  var answer = [];

  correctAnswer.split("[,]").forEach((element, index) => {
    if (index % 2 === 1) {
      answer.push(element);
    }
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{question}</CardTitle>
      </CardHeader>
      <CardBody>
        <Row>
          <Col lg={5}>
            <label style={{ fontWeight: "bolder" }}>
              <FormattedMessage id="CorrectAnswer" />
            </label>
            <br />
            <label>
              {answer.map((cAnswer, index) => {
                return (
                  <div key={"qa" + questionIndex + "ca" + index}>
                    {++index}&nbsp;{cAnswer}&nbsp;
                  </div>
                );
              })}
            </label>
          </Col>
          <Col lg={7}>
            <Slider {...sliderSettings} style={{ width: "95%" }}>
              {answersStudent.map((item, index) => {
                var studentNames = "";
                item.studentIds.forEach((id) => {
                  var student = students.find((obj) => {
                    return obj.id === id;
                  });
                  studentNames +=
                    studentNames === "" ? student.name : ", " + student.name;
                });
                var count = 0;
                return (
                  <div
                    key={"qa" + questionIndex + "sa" + index}
                    className="px-4"
                    style={{ minWidth: "max-content", width: "max-content" }}
                  >
                    <CTooltip content={studentNames} placement="top">
                      <div
                        style={{
                          display: "inline-block",
                          minWidth: "max-content",
                          marginRight: "0.5rem",
                        }}
                      >
                        <Col>
                          <label style={{ fontWeight: "bolder" }}>
                            {Math.round(
                              (item.studentIds.length /
                                amountOfStudentresults) *
                                100
                            )}
                            %&nbsp;
                            {item.isCorrect ? (
                              <span>
                                {"("}
                                <FormattedMessage id="Correct" />
                                {")"}
                              </span>
                            ) : (
                              <span>
                                {"("}
                                <FormattedMessage id="IncorrectOrPartlyCorrect" />
                                {")"}
                              </span>
                            )}
                          </label>
                          <br />
                          <label>
                            {item.answer
                              .split("[,]")
                              .map((answer, answerIndex) => {
                                if (answerIndex % 2 === 1) {
                                  count++;
                                  return (
                                    <div
                                      key={
                                        "qa" +
                                        questionIndex +
                                        "sa" +
                                        index +
                                        "a" +
                                        answerIndex
                                      }
                                    >
                                      {count}&nbsp;{answer}&nbsp;
                                      <br />
                                    </div>
                                  );
                                } else {
                                  return null;
                                }
                              })}
                          </label>
                        </Col>
                      </div>
                    </CTooltip>
                  </div>
                );
              })}
            </Slider>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}
